import { createContext } from 'react';
import { AudioCompanionOption } from '@Components/CreativeAllocation';

interface TagCreationContextValue {
  audioCompanionOptions: AudioCompanionOption[];
}

export const TagCreationContext = createContext<TagCreationContextValue>({
  audioCompanionOptions: []
});
